import { recordingLabel } from "../recordingLabel";
/** Keep the complete ID readable even when a narrow native select clips its label. */
export function RecordingSelectionSummary({recording}:{recording:Parameters<typeof recordingLabel>[0] | undefined}) {
  return recording ? <p className="recording-selection-summary">{recordingLabel(recording)}</p> : null;
}
